import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { ToastProvider } from './components/Toast';

// App version for debugging cache issues
const APP_VERSION = '2.0.1-' + new Date('2024-12-12T21:00:00').getTime();
console.log(`🚀 ThrustED v${APP_VERSION} loaded`);
console.log(`📅 Build: December 12, 2024 - 9:00 PM IST`);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);